<template>
<div ref="platrenewsettingedit" style="position:relative;">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑续费设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="renewsettinglist.length > 1 ? renewsettinglist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回续费记录</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in renewsettinglist" :key="index">
            <div class="TTL-form-submit-box-title">续费模板-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">续费设置名称<i>* </i></label>
                    <div class="TTL-input TTL-form-input"><el-input v-model="item.name" placeholder="请填写续费设置名称" /></div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">微信道具ID</label>
                    <div class="TTL-input TTL-form-input">
                    <el-input v-model="item.product_id" placeholder="与公众平台道具ID一致，不填则默认 renew_套餐id" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">备注</label>
                    <div class="TTL-input TTL-form-input">
                    <el-input type="textarea" v-model="item.note" class="width350" :autosize="{ minRows: 3, maxRows: 6}" />
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">详情设置</label>
                    <div class="TTL-editors" @mousedown="currentEditorIndex=index">
                    <QuillEditor
                        ref="renewEditors"
                        :content="item.content"
                        :options="editorOptions"
                    />
                    </div>
                </el-form-item>
                <el-form-item class="top40">
                    <div class="TTL-button TTL-btn-option"><el-button @click="addmenus(index)">编辑续费设置功能</el-button></div>
                    <div class="TTL-button TTL-btn-option"><el-button @click="settingtimes(index)">设置时间</el-button></div>
                    <div class="TTL-cost-money"><i>续费金额合计：</i>￥{{item.cost}}</div>
                </el-form-item>
                <el-form-item>
                    <div class="TTL-table top20">
                    <el-table :data="item.detail" stripe="true" empty-text="">
                        <el-table-column label="续费功能" align="center">
                            <template #default="scope">
                                <div class="TTL-input TTL-form-input"><el-input v-model="scope.row.menu_name" placeholder="请选择续费功能" readonly @click="GetMenus(index,scope.$index)" /></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="续费时长" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-append TTL-form-input">
                                <el-input v-model="pscope.row.time" placeholder="请填写续费时常">
                                <template #append>
                                <div class="TTL-select">
                                <el-select v-model="pscope.row.timetype" placeholder="请选择时间类型">
                                <el-option v-for="(tt,ii) in timetypelist" :key="ii" :value="tt.id" :label="tt.name" />
                                </el-select>
                                </div>
                                </template>
                                </el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="续费续费金额" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-append TTL-form-input">
                                <el-input v-model="pscope.row.cost" placeholder="请选择续费金额" @change="changeTotals">
                                <template #append>元</template>
                                </el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-form-input"><el-input v-model="pscope.row.note" placeholder="请填写备注" /></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template #default="pscope">
                                <div class="TTL-button">
                                <el-button type="del" @click="delrenewdetail(index,pscope.$index)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>

    <!-- 设置续费时间 -->
    <el-dialog v-model="settingtimetypes.view" title="设置续费时间" width="350">
        <div class="TTL-input TTL-append TTL-form-input">
            <el-input v-model="settingtimetypes.value" placeholder="请填写续费时常">
                <template #append>
                    <div class="TTL-select">
                        <el-select v-model="settingtimetypes.timetype" placeholder="请选择时间类型">
                        <el-option v-for="(tt,ii) in timetypelist" :key="ii" :value="tt.id" :label="tt.name" />
                        </el-select>
                    </div>
                </template>
            </el-input>
        </div>
        <div class="TTL-page-box top50" style="justify-content:end">
        <div class="TTL-page TTL-page-right">
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" @click="settingtimetypes.view=false">取消</el-button>
            </div>
            <div class="TTL-button TTL-btn-option">
            <el-button @click="saveTimeSetting">确定</el-button>
            </div>
        </div>
        </div>
    </el-dialog>

    <!-- 查看付费功能信息 -->
    <el-drawer v-model="authview" title="查看收费功能" size="45%">
        <div class="TTL-input width300"><el-input placeholder="功能名称" v-model="menukey" @input="changeMenusname" clearable /></div>
        <div class="TTL-search-list top20">
            <div class="TTL-table top20">
                <el-table :data="menulist" stripe="true" empty-text="">
                    <template v-slot:empty><el-empty description="暂无数据" /></template>
                    <el-table-column prop="id" label="id" align="center" />
                    <el-table-column prop="menu_name" label="功能名称" align="center" min-width="160" />
                    <el-table-column prop="cost" label="续费金额 / 月" align="center" />
                    <el-table-column label="操作" align="center" min-width="140">
                        <template #default="scope">
                            <div class="TTL-button">
                            <el-button @click="selectMenus(scope.$index)">选择</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-drawer>

    <systemphotos
        v-model:isshow="photoShow"
        :issingle="true"
        phototype="system"
        returnSize="large"
        dialogTitle="系统图集"
        @finish="handlePhotoFinish"
    />

</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_RENEW from '@/Interface/Renew/renew';
import {QuillEditor} from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import systemphotos from '@/components/systemphotos/index';
export default {
    components:{QuillEditor, systemphotos},
    data() {
        return {
            addlimit: 10,           //单次新增限制
            changeSelectIndex:'',   //会员选择序号
            currentEditorIndex:0,
            photoShow:false,
            editorOptions: {
                debug: 'info',
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                            [{ 'script': 'sub'}, { 'script': 'super' }],
                            [{ 'indent': '-1'}, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['45px','60px','90px'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial'] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['image']
                        ],
                        handlers: {
                            image: this.UploadImage
                        }
                    }
                },
                placeholder: '请输入续费详情',
                readOnly: false,
                theme: 'snow'
            },
            timetypelist:[{id:1,name:'日'},{id:2,name:'月'},{id:3,name:'年'},{id:4,name:'K'},{id:5,name:'M'},{id:6,name:'G'}],
            settingtimetypes: {
                index:'',
                timetype:'',
                value:'',
                view:false
            },
            renewsettinglist:[             //版本列表
                {id:'',name:'', cost:'', note:'', content:'', product_id:'', detail:[]}
            ],      
            shopindex:'',
            menuindex:'',
            authview:false,
            menukey:'',
            basemenulist:[],
            menulist:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.GetRenewSettingInfo(data.ids); //获取续费设置信息详情
                }).catch(()=> {
                    
                });
            }else if(data.reload) { //获取续费设置信息详情
                
            }else {
                var _this=this;
                setTimeout(function() {
                    _this.GetRenewSettingInfo(data.ids);
                },150);
            } 
        },


        /** 提交数据 **/
        submitData() {
            this.syncEditorContent();
            //调整提交数据
            var data=[];
            var info;
            var obj;
            for(var i=0;i<this.renewsettinglist.length;i++) {
                obj=this.renewsettinglist[i];
                info={id:obj.id,name:obj.name, cost:obj.cost, note:obj.note, content:obj.content, detail:obj.detail};
                data.push(info);
            }
            data=JSON.stringify(data);

            var loadingobj=this.$refs.platrenewsettingedit;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_RENEW.EDIT_RENEW_SETTING({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.GoBackPets(true); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 编辑续费设置功能 **/
        addmenus(index) {
            var renewinfo={menu_id:'' ,menu_name:'', timetype:2, time:'', cost:'', note:''};
            this.renewsettinglist[index].detail.push(renewinfo);
        },


        /** 设置功能续费时间 **/
        settingtimes(index) {
            this.settingtimetypes.index=index;
            this.settingtimetypes.timetype=1;
            this.settingtimetypes.value='';
            this.settingtimetypes.view=true;
        },


        /** 保存设置时长信息 **/
        saveTimeSetting() {
            if(this.settingtimetypes.timetype=='') {this.$notice({title:'消息提示',message:'请选择续费时长类型',type:'warning'});;return false;}
            if(this.settingtimetypes.value=='') {this.$notice({title:'消息提示',message:'请选择续费时长',type:'warning'});;return false;}
            var index=this.settingtimetypes.index;
            var obj=this.renewsettinglist[index].detail;
            for(var i in obj) {
                obj[i].timetype=this.settingtimetypes.timetype;
                obj[i].time=this.settingtimetypes.value;
            }
            this.settingtimetypes.view=false;
        },


        /** 关键字搜索费用信息 **/
        changeMenusname() {
            this.menulist=[];
            var key=this.menukey;
            var obj;
            var menu_name;
            var index=-1;
            for(var i in this.basemenulist) {
                obj=this.basemenulist[i];
                menu_name=obj.menu_name;
                if(!key || key=='') { //空字符串搜索
                    this.menulist.push(obj);
                }else { //非空字符串搜索
                    index=menu_name.indexOf(key);
                    if(index > -1) this.menulist.push(obj);
                }
            }
        },


        /** 选中菜单信息 **/
        selectMenus(index) {
            this.authview=false;
            var obj=this.menulist[index];
            var menuobj=this.renewsettinglist[this.shopindex].detail[this.menuindex];
            menuobj.menu_id=obj.id;
            menuobj.menu_name=obj.menu_name;
            menuobj.timetype=2;
            menuobj.time=1;
            menuobj.cost=obj.cost;

            //调整续费金额合计
            this.changeTotals();
        },

        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载


        /** 获取续费信息设置 **/
        GetRenewSettingInfo(ids) {
            INTERFACE_MODEL_RENEW.GET_RENEW_SETTING_INFO({ids:ids}).then((res) => {
                if(res.status > 0) return false;
                this.renewsettinglist=res.data;
                this.$nextTick(()=> { this.fillEditorContent(); });
            });
        },


        /** 调整续费金额合计 **/
        changeTotals() {
            var totals=0;
            var renewobj;
            var menuobj;
            for(var i=0;i < this.renewsettinglist.length;i++) {
                totals=0;
                renewobj=this.renewsettinglist[i];
                for(var ii=0;ii < renewobj.detail.length;ii++) {
                    menuobj=renewobj.detail[ii];
                    menuobj.cost > 0 ? totals+=parseFloat(menuobj.cost) : "";
                }
                renewobj.cost=totals;
            }

        },


        /** 获取付费功能信息 **/
        GetMenus(shopindex,menuindex) {
            this.shopindex=shopindex;
            this.menuindex=menuindex;
            this.authview=true;
            this.basemenulist=[];  

            INTERFACE_MODEL_SHOP.GET_AUTH_RENEW().then((res) => {
                 if(res.status > 0) return false;
                 this.basemenulist=res.data;
                 this.menulist=res.data;
            });
        },


        /** 切换店铺信息 **/
        changeShops(index) {
            var shopid=this.renewsettinglist[index].shopid;
            var shoplist=this.renewsettinglist[index].shoplist;
            var obj;
            for(var i in shoplist) {
                if(shoplist[i].id==shopid) obj=shoplist[i];
            }
            this.renewsettinglist[index].shopname=obj.shopname;
            this.renewsettinglist[index].phone=obj.phone;
        },


        /** 获取账号模板 **/
        GetShopLists(keyname) {
            if(!keyname || keyname=='') return false; //传入空字符串时不执行搜索
            var param={key:keyname,p:1,rollpage:1000000};
            INTERFACE_MODEL_SHOP.GET_PLATFORM_SHOP(param).then((res) => {
                 if(res.status > 0) return false;
                 var shops=res.data.list;
                 this.renewsettinglist[this.changeSelectIndex].shoplist=[];
                 this.renewsettinglist[this.changeSelectIndex].shoplist=shops;
            });
        },


        /** 标记当前正在选择的会员 **/
        changeSelect(index) {
            this.changeSelectIndex=index;
        },

        /** 删除功能设置 **/
        delrenewdetail(index,subindex) {
            this.renewsettinglist[index].detail.splice(subindex,1);
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.renewsettinglist);
            localStorage.setItem('editprenewdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('editprenewdata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.renewsettinglist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'续费设置',labelentry:'PlatFormCostSetting',components:'PlatFormCostSetting',isshow:false};
            var data={Method:'',reload:true};
            if(isdellocal) data.delcomponents='EditPlatFormCostSetting';
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj);
        },

        /** 重置加载数据 **/
        resetParam() {
            this.renewsettinglist=[];
            var renewinfo={id:'',name:'', cost:'', note:'', content:'', product_id:'', detail:[]};
            this.renewsettinglist.push(renewinfo);
            this.SaveDataToBrowser();
            this.$nextTick(()=> { this.fillEditorContent(); });
        },

        getEditorByIndex(index) {
            var eds=this.$refs.renewEditors;
            if(!eds) return null;
            if(Array.isArray(eds)) return eds[index] || null;
            return index===0 ? eds : null;
        },
        syncEditorContent() {
            for(var i=0;i<this.renewsettinglist.length;i++) {
                var editor=this.getEditorByIndex(i);
                if(editor && editor.getHTML) this.renewsettinglist[i].content=editor.getHTML();
            }
        },
        fillEditorContent() {
            var _this=this;
            setTimeout(function() {
                for(var i=0;i<_this.renewsettinglist.length;i++) {
                    var editor=_this.getEditorByIndex(i);
                    if(editor && editor.setHTML) editor.setHTML(_this.renewsettinglist[i].content || '');
                }
            },200);
        },
        cursorMove(index) {
            var editor=this.getEditorByIndex(index);
            if(!editor || !editor.getQuill) return 0;
            var length=editor.getQuill().getLength();
            length++;
            editor.getQuill().setSelection(length);
            return length;
        },
        UploadImage() {
            this.photoShow=true;
        },
        handlePhotoFinish(val) {
            this.photoShow=false;
            if(!val || val.type=='cannel' || !val.data || !val.data.length) return false;
            var editorIndex=this.currentEditorIndex;
            var editor=this.getEditorByIndex(editorIndex);
            if(!editor || !editor.getQuill) return false;
            for(var i=0;i<val.data.length;i++) {
                var index=this.cursorMove(editorIndex);
                editor.getQuill().insertEmbed(index, 'image', val.data[i]);
                this.cursorMove(editorIndex);
            }
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-form-label i {font-weight: normal;font-size: 12px;}
.TTL-cost-money {font-size:13px;margin-right:20px;font-weight: 550;letter-spacing: 1px;color:crimson;}
.TTL-cost-money i {font-style: normal;font-weight: normal;letter-spacing: 2px;font-size:13px;color:#333333;}
.TTL-search {font-size: 12px;color: crimson;margin-left:10px;letter-spacing: 2px;display:inline-block;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input .el-input__wrapper) {box-shadow: none !important;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input.is-focus .el-input__wrapper) {box-shadow: none !important;}
::v-deep(.TTL-select .el-input__inner) {text-align: center;}
.TTL-search-shop {display:inline-block;width:100%;}
.TTL-search-shop-in {display: inline-block;padding:15px;border-radius: 6px;background-color: #F2F6FC;width: 15%;border:1px dashed #D4D7DE;}
.TTL-search-details {font-size: 12px;letter-spacing: 2px;display:inline-block;width:100%;color: #666666;}
.TTL-search-list {display: inline-block;width:100%;height:88%;overflow-y:auto;}
.TTL-search-list::-webkit-scrollbar {width:0;}
.TTL-menus-infos {display: inline-flex;width:100%;align-items: center;position:relative;padding:20px 0;}
.TTL-menus-menuname {width:calc(45% - 30px);font-size: 13px;line-height:21px;color:#666666;letter-spacing: 2px;}
.TTL-menus-cost {font-size:12px;font-weight: 550;color:red;width:40%;text-align: center;}
.TTL-menus-btn {cursor: pointer;width:22px;height:22px;background-image:url(@/assets/icon/right-blue.png);background-repeat: no-repeat;background-size: 22px;background-position: center;}
.TTL-editors {display: inline-block;width:70%;}
</style>